import { render, staticRenderFns } from "./ActivateAccount.vue?vue&type=template&id=4624ba78&scoped=true&"
import script from "./ActivateAccount.vue?vue&type=script&lang=js&"
export * from "./ActivateAccount.vue?vue&type=script&lang=js&"
import style0 from "./ActivateAccount.vue?vue&type=style&index=0&id=4624ba78&scoped=true&lang=css&"
import style1 from "./ActivateAccount.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4624ba78",
  null
  
)

export default component.exports